import {useGetTenantInfo} from '../hooks/useGetTenantInfo';
import {VehicleForm as VFKit} from '../VehicleForm';

export function EngineSpecsGroup() {
  const {isBelgianTenant} = useGetTenantInfo();

  return (
    <>
      <VFKit.SimpleNumericField name="power" />
      <VFKit.SimpleNumericField name="maximalPower" />
      <VFKit.ShowWhen name="fuelType" condition={(fuelType) => fuelType?.[0] === 'FUELTYPE_HYBRID'}>
        <>
          <VFKit.SimpleNumericField name="powerCombustionEngine" />
          <VFKit.SimpleNumericField name="powerElectricEngine" />
        </>
      </VFKit.ShowWhen>
      <VFKit.ShowWhen when={isBelgianTenant}>
        <>
          <VFKit.EngineVolumeField />
          <VFKit.FiscalPowerField />
        </>
      </VFKit.ShowWhen>
      <VFKit.ShowWhen when={!isBelgianTenant}>
        <VFKit.SimpleNumericField name="engineVolume" />
      </VFKit.ShowWhen>

      <VFKit.SimpleNumericField name="cylinderCount" />
    </>
  );
}
